'use strict';

module.exports = {
  SPLIT_KILLED: 'killed',
  NO_CONDITION_MATCH: 'default rule',
  SPLIT_NOT_FOUND: 'definition not found',
  EXCEPTION: 'exception',
  SPLIT_ARCHIVED: 'archived',
  NOT_IN_SPLIT: 'not in split'
};


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/utils/labels/index.js
// module id = 263
// module chunks = 10